"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/course/TestAnswerFeedback/constants");
const feedback_1 = require("../../feedback");
exports.default = { [constants_1.TYPE]: { style: feedback_1.FEEDBACK_SCHEMA_EMPTY, font: {}, feedback: {} } };
